"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SubscriptionPurchaseItem;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _helpers = require("../../helpers");
var _Translations = require("react-platform-components/dist/Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function SubscriptionPurchaseItem(props) {
  var item = props.item,
    subscription = props.subscription,
    index = props.index,
    setDeleteOpen = props.setDeleteOpen,
    setSelectedSubscription = props.setSelectedSubscription;
  var expireDate = (0, _helpers.findExpireDate)(subscription.started_at, subscription.duration);
  var isExpired = (0, _helpers.dateIsExpired)(expireDate);
  return !isExpired && /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    button: true,
    divider: index + 1 < item.purchase_salable_items.length ? true : false,
    key: index
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      md: 1,
      xs: 2
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "subtitle2"
    }, "".concat(item.total_price, " ").concat(subscription.salable_item.currency))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      md: 11,
      xs: 10
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6"
    }, subscription.salable_item.name, subscription.is_cancelled && /*#__PURE__*/_react.default.createElement(_core.Chip, {
      label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Cancelled",
        defaultMessage: "Cancelled"
      }),
      color: "primary",
      size: "small",
      className: "ml-4"
    }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "overline"
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Expires at :",
      defaultMessage: "Expires at :"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2 mr-4"
    }, expireDate.format('D MMMM YYYY')))))))
  }), !subscription.is_cancelled && /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick(event) {
      event.preventDefault();
      setDeleteOpen(true);
      setSelectedSubscription(subscription);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "delete"))));
}